import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';

const useDictionariesMetricsTable = ({ category, code }) => useSelector(({ datasetMetrics: { datasetMetrics } }) => {
  const item = findResult(datasetMetrics, category, code);
  const dictionaries = item?.dictionaries;

  return {
    isLoading: item?.readStatus === states.PENDING,
    metrics: dictionaries?.length ? dictionaries : undefined,
    noDictionaries: item?.readStatus === states.SUCCESS && dictionaries?.length === 0,
  };
});

const useDatasetMetricsTable = ({ category, code }) => useSelector(({ datasetMetrics: { datasetMetrics } }) => {
  const item = findResult(datasetMetrics, category, code);
  return { isLoading: item?.readStatus === states.PENDING, metrics: item?.requests };
});

export default {
  useDatasetMetricsTable,
  useDictionariesMetricsTable,
};
